<template>
  <div 
    class="custom-radio"
    :class="{
      'is-checked': isChecked,
      'is-disabled': disabled
    }"
    @click="handleClick"
  >
    <span class="custom-radio__inner"></span>
    <span class="custom-radio__label">
      <slot>{{ label }}</slot>
    </span>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: [String, Number, Boolean],
    default: undefined
  },
  label: {
    type: [String, Number, Boolean],
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  },
  // 是否允许取消选中
  allowUncheck: {
    type: Boolean,
    default: true
  }
});

const emit = defineEmits(['update:modelValue', 'change']);

const isChecked = computed(() => {
  return props.modelValue === props.label;
});

const handleClick = () => {
  if (props.disabled) return;
  
  if (isChecked.value && props.allowUncheck) {
    // 如果已选中且允许取消，则取消选中
    emit('update:modelValue', undefined);
    emit('change', false);
  } else if (!isChecked.value) {
    // 如果未选中，则选中
    emit('update:modelValue', props.label);
    emit('change', true);
  }
};
</script>

<style scoped>
.custom-radio {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  margin-right: 16px;
}

.custom-radio__inner {
  position: relative;
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 1px solid #dcdfe6;
  border-radius: 50%;
  margin-right: 8px;
  box-sizing: border-box;
  transition: all 0.2s;
}

.custom-radio__inner::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  width: 5px;
  height: 5px;
  border-radius: 50%;
  /* background-color: #2684FC; */
  background-color: #fff;
  box-shadow: 0 0 0 4px #2684FC;
  transition: all 0.1s;
}

.custom-radio.is-checked .custom-radio__inner {
  border-color: #2684FC;
}

.custom-radio.is-checked .custom-radio__inner::after {
  transform: translate(-50%, -50%) scale(1);
}

.custom-radio.is-disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.custom-radio.is-disabled .custom-radio__inner {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
}

.custom-radio.is-disabled.is-checked .custom-radio__inner::after {
  background-color: #c0c4cc;
}
</style>